/**
 * Scoped (`/:tenantId/:companyId/*`) routes-д shell-гүй (POS, Print) layout.
 * RequireAuth + TenantScopeProvider бүртгэгдэнэ; URL-аас уншсан scope-аар
 * api/client.ts-д `setApiActiveScope` дуудна.
 */
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { ToastProvider } from '@/app/providers/ToastProvider';
import { TenantScopeProvider } from '@/app/providers/TenantScopeProvider';
import { RequireAuth } from '@/shared/auth/RequireAuth';

export function ScopedAuthLayout() {
  return (
    <AuthProvider>
      <ToastProvider>
        <RequireAuth>
          <TenantScopeProvider>
            <Outlet />
          </TenantScopeProvider>
        </RequireAuth>
      </ToastProvider>
    </AuthProvider>
  );
}
